import { render, staticRenderFns } from "./PartnershipsForm.html?vue&type=template&id=bc26e51a&external"
import script from "./PartnershipsForm.vue?vue&type=script&lang=js"
export * from "./PartnershipsForm.vue?vue&type=script&lang=js"
import style0 from "./PartnershipsForm.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports